import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import default_avatar from "../../../assets/img/default-avatar.png";
import default_avatar_PF_man from "../../../assets/img/PF man.svg";
import default_avatar_PF_woman from "../../../assets/img/PF woman.svg";
import default_avatar_PFA from "../../../assets/img/PFA.svg";
import default_avatar_PJ from "../../../assets/img/PJ.svg";
import { PartnerEditButton, PartnerEditButtonIcon } from "./ListStyles";
import { Card, IconButton } from "@totalsoft/rocket-ui";
import useLocator from "hooks/useLocator";

const ListItem = ({ data }) => {
  const { t } = useTranslation();
  const { isBank, isSelfPartner, path } = useLocator();

  const hidePartnerTypes = useMemo(() => isBank || isSelfPartner, [isBank, isSelfPartner]);

  const defaultLogo = data.isPJ
    ? default_avatar_PJ
    : data.isPF
    ? data.genderCode === "M"
      ? default_avatar_PF_man
      : data.genderCode === "F"
      ? default_avatar_PF_woman
      : default_avatar
    : default_avatar_PFA;

  const onError = ev => {
    ev.target.src = defaultLogo;
  };

  return (
    <Card>
      <Grid
        container
        gap={1}
        id={"partnerList_partner_" + data.id}
        flexWrap="nowrap"
        alignItems="center"
        position="relative"
      >
        <Grid item textAlign="center" pl={2} pr={4}>
          <img className="logo-image-list" src={data.logoUrl || defaultLogo} onError={onError} alt="..." />
        </Grid>
        <Grid container item width="auto" flexGrow={1}>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerName"}>
            <strong> {t("Partner.Name")}</strong>: <span>{data.partnerName}</span>
          </Grid>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_uniqueId"}>
            <strong> {t("Partner.UniqueID")}</strong>: <span>{data.uniqueId}</span>
          </Grid>
          {!hidePartnerTypes && (
            <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerType"}>
              <strong> {t("Partner.Type")}</strong>: <span>{data.partnerTypeName}</span>
            </Grid>
          )}
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerLocation"}>
            <strong> {t("Partner.Location")}</strong>: <span>{data.location}</span>
          </Grid>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerRepresentative"}>
            <strong> {t("Partner.Representative")}</strong>: <span>{data.representatives}</span>
          </Grid>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerPhone"}>
            <strong> {t("Partner.Phone")}</strong>: <span>{data.phoneNumber}</span>
          </Grid>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partner_" + data.id + "_partnerEmail"}>
            <strong> {t("Partner.Email")}</strong>: <span>{data.e_mail}</span>
          </Grid>
        </Grid>
        <PartnerEditButton to={`/${path}/${data.id}`}>
          <IconButton id={`partner_editBtn_${data.id}`} size="small" color="primary">
            <PartnerEditButtonIcon />
          </IconButton>
        </PartnerEditButton>
      </Grid>
    </Card>
  );
};

ListItem.propTypes = {
  data: PropTypes.object.isRequired
};

export default ListItem;
